var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"liveness"},[_c('h6',[_vm._v("Liveness check.")]),_c('div',{staticClass:"liveness__container"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }